import { render, staticRenderFns } from "./discordbot.vue?vue&type=template&id=564ae128&scoped=true&"
import script from "./discordbot.vue?vue&type=script&lang=js&"
export * from "./discordbot.vue?vue&type=script&lang=js&"
import style0 from "./discordbot.vue?vue&type=style&index=0&id=564ae128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564ae128",
  null
  
)

export default component.exports